// helpers/gridHelpers.js

import CustomDropdownEditor from "../cellComponents/Dropdown/CustomDropdownEditor";
import { CustomDropdownRenderer } from "../cellComponents/Dropdown/CustomDropdownRenderer";
import { CustomDateRenderer } from "../components/Grid/CustomDateRenderer";

export const gridRefreshFunction = async (gridRef, formatRows, setRowData, colIdObj, parentList, setParentList, setRefreshGrid, makeRowsForDB, storeLastRenderedRow, currentSelectedSheet,columnDefs,setRows) => {
    let rows = makeRowsForDB(gridRef, columnDefs);
    setRefreshGrid(true);
    storeLastRenderedRow(gridRef, currentSelectedSheet.id);
    setRows([]);
    setTimeout(() => {
        formatRows(rows, setRowData, colIdObj, parentList, setParentList);
        setRefreshGrid(false);
    }, 1000);
};
export function isThereDataToBeSaved (gridChangesPerSaveSession){
    if (gridChangesPerSaveSession) {
        const { add, update, delete: del } = gridChangesPerSaveSession;
        if (Object.keys(add).length === 0 && Object.keys(update).length === 0 && Object.keys(del).length === 0) {
            return false; // Return from the function if no changes
        }
        return true
    }
    return true;
}

export const DropdownRendererWrapperForAzure = (params,updateRowD,onCellValueChanged,gridRef) => {
     
    const col = params.colDef.field + "_es";
    const isSelectionType =
      params.colDef.type?.toLowerCase() === "person" ||
      params.colDef.type?.toLowerCase() === "assignee"
        ? "person"
        : params.colDef.type?.toLowerCase() === "dropdown"
        ? "multiple"
        : "single";
  
    return (
      <CustomDropdownRenderer
        params={params}
        updateDB={(newValue) =>
          updateRowD({
            params,
            newVal: newValue,
            data: params.data,
            rowIndex: params.rowIndex,
            colId: col,
            gridRef,
            onCellValueChanged,
            field: params.colDef.field,
          })
        }
        isSelectionType={isSelectionType}
      />
    );
  };
  export const DropdownEditorWrapperForAzure=(params,updateRowD,onCellValueChanged,gridRef)=>{
     
    let col = params.colDef.field + '_es';
    let isSelectionType = (params.colDef.type.toLowerCase() === "person" || params.colDef.type.toLowerCase() === "person") ?"person":params.colDef.type.toLowerCase() === "dropdown" ? "multiple" : "single";
    return <CustomDropdownEditor params={params} updateDB={(newValue) => {
      updateRowD({params, newVal: newValue, data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})}}
     isSelectionType={isSelectionType}
     />
}
export const  DateRendererWrapperForAzure = (params,updateRowD,onCellValueChanged,gridRef) => {
   
  let col = params.colDef.field + '_es';
  return <CustomDateRenderer params={params} columnSubType={'None'} updateRowDHelper={(newValue) => updateRowD({params, newVal: newValue,data: params.node.data, rowIndex: params.rowIndex, colId:col, gridRef, onCellValueChanged, field: params.colDef.field})}  />
}
export const StatusRollupRendererWrapperForAzure = (params,updateRowD,onCellValueChanged,gridRef) => {
   
  let col = params.colDef.field + '_es';
  return <CustomDropdownRenderer params={params} updateDB={(newValue) => 
    updateRowD({params, newVal: newValue,data: params.data, rowIndex: params.rowIndex, colId: col, gridRef, onCellValueChanged, field: params.colDef.field})
   } />
}
export const StatusRollupEditorWrapperForAzure=(params,updateRowD,onCellValueChanged,gridRef)=>{
   
  let col = params.colDef.field + '_es';
  return <CustomDropdownEditor params={params} updateDB={(newValue) => {
    updateRowD({params, newVal: newValue, data: params.data, rowIndex: params.rowIndex, colId: col,gridRef,onCellValueChanged, field: params.colDef.field})
        }}
  //  updateListData={updateListData}
  />
}